// extracted by mini-css-extract-plugin
module.exports = {"Impressum":"Impressum_Impressum__2tQ_9"};